import Api from '../utils/Api';
import { createNotification } from './notifications';

export const CREATE_REGISTRATION_REQUEST = 'CREATE_REGISTRATION_REQUEST';
export const CREATE_REGISTRATION_SUCCESS = 'CREATE_REGISTRATION_SUCCESS';
export const CREATE_REGISTRATION_FAILURE = 'CREATE_REGISTRATION_FAILURE';

const createRegistrationRequest = () => ({
  type: CREATE_REGISTRATION_REQUEST
});

const createRegistrationSuccess = data => dispatch => {
  const messages = [
    { text: 'Welcome to the pack. Please check your email', type: 'success' }
  ];
  dispatch(createNotification(messages));
  dispatch({
    type: CREATE_REGISTRATION_SUCCESS,
    user: data.user
  });
};

const createRegistrationFailure = error => dispatch => {
  error.response.json().then(messages => {
    const errorMessages = messages.map(message => ({
      text: message,
      type: 'error'
    }));
    dispatch(createNotification(errorMessages));
    dispatch({
      type: CREATE_REGISTRATION_FAILURE
    });
  });
};

export const createRegistration = params => dispatch => {
  dispatch(createRegistrationRequest());
  return Api.createRegistration(params)
    .then(data => dispatch(createRegistrationSuccess(data)))
    .catch(error => dispatch(createRegistrationFailure(error)));
};



// WEBPACK FOOTER //
// ./src/actions/registrations.js